<template lang="pug">
  .selectDates
    .top
      a.prev(@click='prevMonth()')
        i.fa.fa-arrow-left        
      .month {{monthName}} {{year}}
      a.next(@click='nextMonth()')
        i.fa.fa-arrow-right
    table
      tr
        th(v-for='(day, index) in days', @click='toggleSelectAll(index)', :key="index") {{day}}
      tr(v-for='w in nbWeeks', :key="w")
        td(v-for='d in 7', :class='{before: ((w - 1) == 0 && (d - 1) < firstDay), after: ((w - 1) * 7 + (d - 1) >= lastDay + firstDay), selected: isSelected((w - 1) * 7 + (d - 1) - firstDay), inPast: inPast((w - 1) * 7 + (d - 1) - firstDay + 1)}', @click='toggleSelect((w - 1) * 7 + (d - 1) - firstDay)', :key="d")
          template(v-if='!(((w - 1) == 0 && (d - 1) < firstDay) || ((w - 1) * 7 + (d - 1) >= lastDay + firstDay))') {{(w - 1) * 7 + (d - 1) - firstDay + 1}}
</template>
<script>
import moment from 'moment'
import _ from 'lodash'

export default {
  props: {
    selectedDates: {
      required: true
    }
  },
  data: function () {
    return {
      currentMonth: moment().startOf('month')
    }
  },
  computed: {
    days: function () {
      return ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di']
    },
    firstDay: function () {
      return (this.currentMonth.day() - 1 + 7) % 7
    },
    lastDate: function () {
      return this.currentMonth.clone().endOf('month')
    },
    lastDay: function () {
      return this.lastDate.date()
    },
    nbWeeks: function () {
      return Math.ceil((this.lastDay + this.firstDay) / 7)
    },
    year: function () {
      return this.currentMonth.year()
    },
    monthName: function () {
      return _.upperFirst(this.currentMonth.format('MMMM'))
    }
  },
  methods: {
    initValues: function () {
      this.currentMonth = moment().startOf('month')
    },
    nextMonth: function () {
      this.currentMonth = this.currentMonth.add(1, 'month').clone()
    },
    prevMonth: function () {
      this.currentMonth = this.currentMonth.subtract(1, 'month').clone()
    },
    isSelected: function (date) {
      if (date < 0 || date >= this.lastDay) {
        return false
      }
      date = this.currentMonth.clone().set('date', date + 1).format('L')
      return this.selectedDates[date] !== void 0
    },
    toggleSelect: function (date) {
      var dateS
      if (date < 0 || date >= this.lastDay) {
        return false
      }
      date = this.currentMonth.clone().set('date', date + 1)
      dateS = date.format('L')
      if (typeof this.selectedDates[dateS] === 'undefined') {
        this.$set(this.selectedDates, dateS, date)
      } else {
        this.$delete(this.selectedDates, dateS)
      }
    },
    toggleSelectAll: function (day) {
      var date, firstDay
      firstDay = (day - this.currentMonth.day() + 7 + 1) % 7
      date = this.currentMonth.clone().set('date', firstDay + 1)
      while (date.month() === this.currentMonth.month()) {
        this.toggleSelect(date.date() - 1)
        date.add(7, 'days')
      }
    },
    inPast (date) {
      let m = this.currentMonth.clone().set('date', date)
      return m.isBefore(moment().startOf('day'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// VueSelectDates.vue?1db3d82c